import React, { cloneElement, ForwardedRef, forwardRef, ReactElement } from 'react';
import times from 'lodash/times';
import { Flex, FlexProps } from './Flex';

interface ListViewProps extends FlexProps {
    count: number;
    renderItem: (index: number) => ReactElement;
}

export const Stack = forwardRef(
    (props: ListViewProps, ref: ForwardedRef<HTMLDivElement | null>) => {
        const { count, renderItem, ...other } = props;

        return (
            <Flex {...other} role="list" ref={ref}>
                {times(count, (idx) => cloneElement(renderItem(idx), { role: 'listitem' }))}
            </Flex>
        );
    },
);
